// extracted by mini-css-extract-plugin
export default {"wrapper":"layout__wrapper"};